var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('legend', [_vm._v("Logistic Mark Debit-Transit Approval")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchData()
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate')
    },
    attrs: {
      "id": "fromDate",
      "type": "Date",
      "name": "fromDate",
      "placeholder": "Enter From Date"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.fromDate')),
      expression: "errors.has('form-1.fromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select From Date")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("To Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate",
      "placeholder": "Enter To Date"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.toDate')),
      expression: "errors.has('form-1.toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select To Date")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipping Id")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-sm-12",
    attrs: {
      "type": "text",
      "name": "shippingid"
    },
    model: {
      value: (_vm.shippingid),
      callback: function($$v) {
        _vm.shippingid = $$v
      },
      expression: "shippingid"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "col-sm-9",
    class: {
      'form-control': true
    },
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "name": "status",
      "id": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RMApprove"
    }
  }, [_vm._v("RMApprove")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pending"
    }
  }, [_vm._v("Pending")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Debit From")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.debitfrom),
      expression: "debitfrom"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "debitfrom",
      "id": "debitfrom"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.debitfrom = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getHubListByDabit($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Coloader"
    }
  }, [_vm._v("Coloader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Vendor"
    }
  }, [_vm._v("Vendor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NetworkVendor"
    }
  }, [_vm._v("NetworkVendor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubname),
      expression: "hubname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "hubname",
      "id": "hubname"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.hubServiceCenterList), function(hub_obj) {
    return _c('option', {
      domProps: {
        "value": hub_obj.HubID
      }
    }, [_vm._v(_vm._s(hub_obj.HubName))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Vertical")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Vertical),
      expression: "Vertical"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "Vertical",
      "id": "Vertical"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Vertical = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2B"
    }
  }, [_vm._v("B2B")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2C"
    }
  }, [_vm._v("B2C")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" \n                  "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.exportForm
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Export")]), _vm._v(" \n                  "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.searchTransitApprovalLoader
    },
    on: {
      "update:active": function($event) {
        _vm.searchTransitApprovalLoader = $event
      }
    }
  })], 1)])])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowing),
      expression: "isShowing"
    }]
  }, [_c('legend', [_vm._v("Lost Debit Shipments List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post",
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Debit Mode")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ddldebitmode),
      expression: "ddldebitmode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ddldebitmode')
    },
    attrs: {
      "name": "ddldebitmode",
      "id": "ddldebitmode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ddldebitmode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Debit Mode--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cash In Hand"
    }
  }, [_vm._v("Cash In Hand")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cash Against Invoice"
    }
  }, [_vm._v("Cash Against Invoice")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "COF"
    }
  }, [_vm._v("COF")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ddldebitmode')),
      expression: "errors.has('form-1.ddldebitmode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Debit Mode.")])]), _vm._v(" "), (_vm.ddldebitmode == 'Cash In Hand') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Deposit Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depositDate),
      expression: "depositDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('depositDate')
    },
    attrs: {
      "id": "depositDate",
      "type": "Date",
      "name": "depositDate",
      "placeholder": "Enter Deposit Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.depositDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.depositDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.depositDate')),
      expression: "errors.has('form-1.depositDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Deposit Date.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("File Upload")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.ddldebitmode == 'Cash In Hand' || _vm.ddldebitmode == 'COF' ? 'required': ''))),
      expression: "`${ddldebitmode == 'Cash In Hand' || ddldebitmode == 'COF' ? 'required': '' }`"
    }],
    ref: "UploadFile",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "UploadFile",
      "id": "UploadFile",
      "accept": ".png, .jpg, .jpeg, .gif, .bmp, .pdf, .eml, .doc, .docx"
    },
    on: {
      "change": function($event) {
        return _vm.onUpload($event)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "upload-size"
  }, [_vm._v(" Maximum Size : 5 MB | Only png, jpg, jpeg, gif, bmp, pdf, eml, doc, docx format is allow")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.UploadFile')),
      expression: "errors.has('form-1.UploadFile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select file, attachment is required.!")])]), _vm._v(" "), _vm._l((_vm.getUploadError), function(err) {
    return [(err.title == 'success') ? _c('p', {
      staticStyle: {
        "color": "green",
        "margin-top": "40px"
      }
    }, [_vm._v(" " + _vm._s(err.detail))]) : _c('p', {
      staticStyle: {
        "color": "red",
        "margin-top": "40px"
      }
    }, [_vm._v(" " + _vm._s(err.detail))])]
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.isImageLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isImageLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.ddldebitmode == 'Cash In Hand' ? 'col-md-3' : 'col-md-6', _vm.errorClass],
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "margin-right": "10px",
      "margin-top": "30px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.validated ? false : true
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("Approve")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.TransitApproveLoaderbtn
    },
    on: {
      "update:active": function($event) {
        _vm.TransitApproveLoaderbtn = $event
      }
    }
  })], 1)], 2), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("Total Record: " + _vm._s(_vm.totalRecord) + " "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Total Selected : " + _vm._s(_vm.selectedCount) + " ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllItems),
      expression: "selectAllItems"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllItems) ? _vm._i(_vm.selectAllItems, null) > -1 : (_vm.selectAllItems)
    },
    on: {
      "click": function($event) {
        return _vm.selectItems($event)
      },
      "change": function($event) {
        var $$a = _vm.selectAllItems,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllItems = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllItems = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Debit From Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Debit From Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Debit Amount")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Deposit Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub Zone Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comments")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Docket No")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created By")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Modified By")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Modified Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Attachment")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentList), function(shipmentdata) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.shippingidchk),
        expression: "form.shippingidchk"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'category_' + shipmentdata.checkboxval
      },
      domProps: {
        "value": shipmentdata.checkboxval,
        "checked": Array.isArray(_vm.form.shippingidchk) ? _vm._i(_vm.form.shippingidchk, shipmentdata.checkboxval) > -1 : (_vm.form.shippingidchk)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.form.shippingidchk,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = shipmentdata.checkboxval,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, "shippingidchk", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, "shippingidchk", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, "shippingidchk", $$c)
          }
        }, _vm.calculateselectedcount]
      }
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.DebitFromType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.DebitFrom))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.DebitAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.CIHDepositDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.HubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.HubZoneName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.Comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.DocketNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.CreatedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.CreatedDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.LastModifiedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentdata.LastModifiedDate))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getShipmentAttachmentPopup(shipmentdata.ShippingID)
        }
      }
    }, [_vm._v("View Image")])])])
  }), 0)])]), _c('br')], 1), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.getAttachmentFlag = false
      }
    },
    model: {
      value: (_vm.getAttachmentFlag),
      callback: function($$v) {
        _vm.getAttachmentFlag = $$v
      },
      expression: "getAttachmentFlag"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.attachmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.attachmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Attachment ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAttachmentPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto"
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Attachment")])])]), _vm._v(" "), _c('tbody', [(_vm.getAttachmentListData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_vm._v("No Attachments Available.! ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getAttachmentListData), function(val, index) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": val.filePath,
        "target": "_blank",
        "title": val.fileName
      }
    }, [_vm._v(" " + _vm._s(val.fileName))])])])
  })], 2)])])])])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5705d718","hasScoped":true}!./src/views/components/LOST/LogisticMarkDebitTransitApproval/LogisticMarkDebitTransitApproval.component.html
// module id = 1096
// module chunks = 1